import { ls } from "@/helpers/helpers";
import { set } from "lodash";

export const authModule = {
  namespaced: true,
  state: {
    isAuthenticated: false,
    token: null,
    refreshToken: null,
    companyLogo: null,
  },
  getters: {
    getIsAuthenticated: function (state) {
      return state.isAuthenticated;
    },
    getToken: function (state) {
      return state.token;
    },
   getRefreshToken: function (state) {
      return state.refreshToken;
    },
    companyLogo: (state) => state.companyLogo,
  },
  mutations: {
    setIsAuthenticated: function (state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
      state.token = payload.token;
      state.refreshToken = payload.refreshToken;
    },
    clearPersistedState: function (state, payload) {
      ls.removeAll();
      ls.clear();
    },
    setCompanyLogo: (state, payload) => {
      state.companyLogo = payload.companyLogo;
    },
  },
  actions: {
    setIsAuthenticated: function (context, payload) {
      context.commit("setIsAuthenticated", {
        isAuthenticated: payload.isAuthenticated,
        token: payload.token,
        refreshToken: payload.refreshToken,
        companyLogo: payload.companyLogo,
      });
    },
    setCompanyLogo: (context, payload) => {
      context.commit("setCompanyLogo", {
        companyLogo: payload.companyLogo,
      });
    },
    clearPersistedState: function (context, payload) {
      context.commit("clearPersistedState");
    },
  },
};
